import type { DraftInput } from '../../../../shared/drafts';
import { UFO_RULES, type UfoTimingMode } from '../../../../shared/ufoRules';
function question(level: number): DraftInput['questions'][number] {
  return { prompt: `${level}. keşif sorusu`, levels: [level], timeLimitSeconds: UFO_RULES.defaultApproachSeconds,
    choices: [{ text: 'Doğru cevap', isCorrect: true }, { text: 'Yanlış cevap 1', isCorrect: false }, { text: 'Yanlış cevap 2', isCorrect: false }] };
}
export function createUfoDraft(): DraftInput {
  return { title: 'Yeni UFO Macerası', templateKey: 'ufo-adventure', levelMode: 'manual', maxLevels: 5, trackTime: true,
    timingMode: 'per-question', questions: Array.from({ length: 5 }, (_, i) => question(i + 1)) };
}
export function setUfoTiming(draft: DraftInput, timingMode: UfoTimingMode): DraftInput {
  return { ...draft, timingMode, questions: draft.questions.map(q => ({ ...q,
    timeLimitSeconds: timingMode === 'none' ? null : q.timeLimitSeconds ?? UFO_RULES.defaultApproachSeconds })) };
}
export function resizeUfoDraft(draft: DraftInput, count: number): DraftInput {
  const maxLevels = Math.max(UFO_RULES.minQuestions, Math.min(UFO_RULES.maxQuestions, Math.trunc(count)));
  return setUfoTiming({ ...draft, maxLevels, questions: Array.from({ length: maxLevels }, (_, i) =>
    ({ ...(draft.questions.find(q => q.levels[0] === i + 1) ?? question(i + 1)), levels: [i + 1] })) }, draft.timingMode ?? 'per-question');
}
